export const GOOGLE_API_KEY = "AIzaSyCY-IMUNJ5d-1o5KUMhCUBVBnM_Yfklu5E";
export const GOOGLE_MAPS_API_KEY = GOOGLE_API_KEY;
